import { call, select, take } from 'redux-saga/effects';
import { RTCClient } from 'utils/webrtc';
import { RTCClientInitialized } from 'features/application/actions';
import { SignalingSocket } from 'services/signaling';
import { selectAppReconnecting } from 'features/application/applicationSlice';
import { installRtcStats } from 'utils/webrtc/stats/install-rtcstats';
import { prepareRoomJoin } from 'features/room/actions';

export function* prepareRoomJoinSaga(action: ReturnType<typeof prepareRoomJoin>) {
  const isReconnecting: boolean = yield select(selectAppReconnecting);
  if (!isReconnecting) {
    yield call(
      RTCClient.initialize,
      action.payload.roomId,
      action.payload.roomPin,
      action.payload.mountpointId
    );
    yield take(RTCClientInitialized);
    // Install after Janus.init so probe PCs aren't wrapped; wrapper persists for the page lifetime.
    yield call(installRtcStats, action.payload.rtcStatsServer);
  }

  yield call(SignalingSocket.joinRoom);
}
